import * as z from 'zod';

export const AudienceSchema = z.object({
  mailCode: z.string().nullable(),
  primarySelect: z.string().nullish(),
  sequenceNumber: z.number(),
  shopId: z.string().nullish(),
});
